import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getContractsAMC } from 'store/contract/selectors';
import { NEC } from 'constants/globalConstants';
import {
  apiCreatePAC,
  apiOrganismesPAC,
  apiPacCategories,
  apiTokenDM,
} from './apis';
import {
  setCategoryParamPAC,
  setOrganismesPAC,
  setPacResponse,
} from './actions';
import {
  GET_ORGANISMES_PAC,
  GET_PAC_CATEGRY_PARAM,
  SEND_PAC_INFOS,
} from './constants';

export function* getOrganismesPAC() {
  try {
    const token = localStorage.getItem('token');
    const response = yield call(apiOrganismesPAC, { token: token });

    const state = yield select();
    const contracts = getContractsAMC(state);

    if (response.data.success) {
      const pacOrganisme: any[] = [];
      if (response.data.data.length > 0) {
        contracts.map((c: any) => {
          const oragnisme = response.data.data.find(
            (r: any) => r.NUM_POLICE === c.NUM_POLICE,
          );
          oragnisme && pacOrganisme.push(oragnisme);
          return null;
        });
      }
      yield put(setOrganismesPAC(pacOrganisme));
    }
  } catch (error) {
    yield put(setOrganismesPAC(''));
  }
}

export function* getPacCategerieParams(payloadAction: any) {
  const token = localStorage.getItem('token');
  try {
    const numPolice = payloadAction.payload.numPolice;
    const id = payloadAction.payload.Identifiant;
    const payloadSession = {
      username: numPolice.trim(),
      identifiant: id.trim(),
      token: token,
    };
    const resSessionsID = yield call(apiTokenDM, payloadSession);
    const sessionID = resSessionsID.data.session_id;
    const accessToken = resSessionsID.data.access_token;

    const payload = {
      NumPolice: numPolice.trim(),
      NumIdentification: id.trim(),
      token: accessToken,
      sessionsId: sessionID,
    };

    const response = yield call(apiPacCategories, payload);
    if (response.data) {
      yield put(setCategoryParamPAC(response.data));
    }
  } catch (error) {
    yield put(setCategoryParamPAC(null));
  }
}

/* istanbul ignore next */
export function* createPAC() {
  const token = localStorage.getItem('token');
  const state = yield select();
  const pacObject = state.getIn(['pac', 'pacObject']);

  try {
    const numPolice = pacObject.numPolice;
    const id = pacObject.Identifiant;
    const payloadSession = {
      username: numPolice.trim(),
      identifiant: id.trim(),
      token: token,
    };

    const pacCreationObject = {
      ...pacObject,
      IdCategorie: pacObject.category.id,
      numPolice: numPolice.trim(),
      Identifiant: id.trim(),
      NomPrenomPAC: pacObject.Nom + ' ' + pacObject.Prenom,
      NomPrenomADH: pacObject.NomPrenomADH,
      Canal: NEC,
      CanalDemande: NEC,
    };

    delete pacCreationObject.Nom;
    delete pacCreationObject.Prenom;
    delete pacCreationObject.category;

    const resSessionsID = yield call(apiTokenDM, payloadSession);
    const sessionID = resSessionsID.data.session_id;
    const accessToken = resSessionsID.data.access_token;

    const TmpListFiles = pacObject.TmpListFiles.map((element: any) => {
      return {
        NomFichier: element.file.name,
        TypeFichier: element.file.type,
        FileSize: element.file.size,
        ContenuFichier: element.data.split(',')[1],
      };
    });

    const payload = {
      ...pacCreationObject,
      TmpListFiles,
      token: accessToken,
      sessionsId: sessionID,
    };

    const response = yield call(apiCreatePAC, payload);
    if (response.data && response.data.ReferenceDemande) {
      const payload = response.data;
      yield put(setPacResponse(payload));
    } else if (response.data && response.data.Message) {
      const payload = response.data;
      yield put(setPacResponse(payload));
    }
  } catch (error) {
    yield put(setPacResponse(error.response.data));
  }
}

export function* watchGetOrganismesPAC() {
  yield takeLatest(GET_ORGANISMES_PAC, getOrganismesPAC);
}

export function* watchGetPacCategoryParam() {
  yield takeLatest(GET_PAC_CATEGRY_PARAM, getPacCategerieParams);
}

/* istanbul ignore next */
export function* watchCreatePAC() {
  yield takeLatest(SEND_PAC_INFOS, createPAC);
}

export default [
  watchGetOrganismesPAC,
  watchGetPacCategoryParam,
  watchCreatePAC,
];
